import { getPeppolIntegration } from 'api/v2/integrations/peppol';
import useQuery from 'hooks/react-query/useQuery';
import { UseQueryOptions } from '@tanstack/react-query';
import { IntegrationsCacheKeys } from 'types/cacheKeys.types';

const useUserPeppolIntegration = (
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'> & {
    partialKey?: string;
  },
) => {
  return useQuery(
    [IntegrationsCacheKeys.PeppolIntegration, options?.partialKey],
    () => getPeppolIntegration(),
    options as any,
  );
};

export default useUserPeppolIntegration;
